import { inject, Injectable } from '@angular/core';
import { CountriesService } from '../countries/countries.service';
import { IDidCountries, IPackageCountries } from '../../models/countries.model';

export interface ISearchCountriesData {
  didCountries: IDidCountries[];
  packagesCountries: IPackageCountries[];
}

@Injectable({
  providedIn: 'root',
})
export class SearchCountriesService {
  private countryService = inject(CountriesService);

  async getCountriesData(): Promise<ISearchCountriesData> {
    const [didResult, packagesResult] = await Promise.all([
      this.countryService.getDIDCountries<IDidCountries[]>(),
      this.countryService.getPackageCountries<IPackageCountries[]>(),
    ]);

    // Validates and extracts the results
    const didCountries = didResult.isSuccessful ? didResult.result : [];
    const packagesCountries = packagesResult.isSuccessful ? packagesResult.result : [];

    if (!didResult.isSuccessful) {
      console.error('Error fetching did Countries:', didResult.errorMessage);
    }
    if (!packagesResult.isSuccessful) {
      console.error('Error fetching Packages Countries:', packagesResult.errorMessage);
    }

    return { didCountries, packagesCountries };
  }
}
